export default {
  privacy: {
    lastUpdated: 'Last Updated: March 18, 2022',
    companyName: 'Linktivity Inc.',
    title: 'Privacy Policy',
    personalInfoProtectionPolicy: 'Personal Information Protection Policy',
    personalInfoProtectionDescription:
      'Linktivity Inc. (hereinafter "Company") collects personal information from customers on our reservation website LINKTIVITY and other platforms. The Company considers it extremely important to protect customer personal information to enable customers to make reservations with peace of mind and convenience. We handle personal information in accordance with the provisions set forth below.',
    customerDataManager: 'Customer Data Manager',
    companyAddress:
      '19F Hibiya Park Front, 2-1-6 Uchisaiwaicho, Chiyoda Ward, Tokyo 100-0011',
    acquisition: 'Acquisition',
    acquisitionDescription:
      'The Company acquires only the minimum necessary personal information required to achieve its stated purposes of use, and only after obtaining customer consent when required by law.',
    usage: 'Usage',
    usageDescription:
      'The Company uses personal information obtained from customers only to achieve the stated purposes of use.',
    storage: 'Storage and Retention',
    storageDescription:
      'The Company maintains and stores personal information with careful attention to system security to prevent unauthorized disclosure to external parties.',
    destruction: 'Destruction and Deletion',
    destructionDescription:
      'The Company promptly destroys personal data that is no longer needed for use, without delay from the point at which it is no longer needed.',
    customerInquiry: 'Response to Customer Inquiries',
    customerInquiryDescription:
      'The Company responds in accordance with applicable laws to requests from customers regarding the purpose of use of held personal data, requests for disclosure, requests for correction/addition/deletion, requests for suspension/deletion of use, and requests to stop third-party provision.',
    safetyMeasures: 'Safety Management Measures',
    safetyMeasuresDescription:
      'The Company ensures that all staff involved in LINKTIVITY services understand the importance of personal information through education, and implements necessary and appropriate security measures for the protection of personal information.',
    tableOfContents: 'Table of Contents',
    policy1: {
      title: 'Personal Information We Collect and Purposes of Use',
      description:
        'The Company collects and uses personal information including customer addresses, names, dates of birth, contact information, email addresses, and passport numbers for the following stated purposes of use. The Company does not collect sensitive personal information without customer consent. In cases where the purpose of use of personal information is not publicly disclosed at the time of collection, the Company notifies the customer of or publicly discloses the purpose of use of the personal information being collected. The Company does not collect personal information from children under 13 without parental consent. When personal information of children under 13 is provided, we will treat it as having obtained parental consent, but if it becomes clear that consent was not obtained, we will not use the personal information for purposes other than contacting the parent and related purposes.',
      serviceUsage: {
        title: 'For LINKTIVITY Service Use (Member Registration, etc.)',
        description:
          'For LINKTIVITY service use, customer personal information is shared internally within the Company.',
        legalBasis:
          'It is necessary to provide the services and features requested by customers.'
      },
      ticketPurchase: {
        title: 'For Ticket Purchase Applications',
        infoItems:
          'The Company collects customer names, payment information, passport numbers, and information related to customer health status including health conditions and medical history when processing ticket purchase applications from product providers.',
        purpose:
          'The Company collects and uses customer personal information to verify ticket purchase eligibility from product providers and process payment for tickets and related fees. For these purposes, the Company may provide customer personal information to product providers, transportation companies, payment processors, and other service providers (including overseas providers).',
        legalBasis:
          'It is necessary to provide the services and features requested by customers.'
      },
      newsletter: {
        title:
          'For Sending Newsletters (Email Magazines, etc.) and Customer Communications',
        legalBasis: 'Collected based on customer consent.'
      },
      advertising: {
        title:
          'For Advertising through Social Media and Ad Distribution Platforms',
        legalBasis: 'Collected based on customer consent.'
      },
      survey: {
        title: 'For Survey Participation Requests',
        legalBasis:
          'Collected based on customer consent for improvement of our reservation website, products, and services.'
      },
      analysis: {
        title: 'For Customer Information Analysis and Management',
        legalBasis:
          'It is necessary to pursue and protect legitimate customer interests by improving our reservation website, products, and services.'
      },
      fraudDetection: {
        title:
          'For Detection of Fraudulent Use of Credit Cards and Similar Instruments',
        legalBasis:
          'It is necessary to ensure the security of customer credit cards and pursue legitimate customer interests.'
      }
    },
    policy2: {
      title: 'Third-Party Provision of Personal Data',
      description:
        'The Company does not provide personal data obtained from customers to third parties except in the following cases.',
      case1:
        'When the customer has given prior consent to provision of personal data to third parties (including product providers, overseas travel agencies, social media providers, ad distribution service companies, and other service providers) through agreement with this Privacy Policy or by other means.',
      case2:
        'When handling of personal data has been outsourced to third parties within the scope necessary to achieve the stated purposes of use.',
      case3: 'When provision is required by law.',
      case4:
        'When necessary to protect human life, body, or property, and obtaining customer consent would be difficult.',
      case5:
        'When specially necessary for improving public health or promoting the healthy development of children, and obtaining customer consent would be difficult.',
      case6:
        'When cooperation is necessary for government or local government implementation of duties prescribed by law, and obtaining customer consent would hinder the execution of such duties.'
    },

    policy3: {
      title: 'Delegation of Handling of Personal Data',
      description:
        'When the Company delegates handling of customer personal data to third parties within the scope necessary to achieve its stated purposes of use, the Company provides necessary and appropriate oversight to the delegated parties. If a delegated party further delegates to another party, the Company directly or indirectly oversees whether the delegated party provides necessary and appropriate oversight to the re-delegated party. The same applies when a re-delegated party further delegates.'
    },
    policy4: {
      title: 'Collection of Cookie Information, etc.',
      cookie: {
        title: 'Cookies',
        description1:
          "A cookie is a data file stored on a user's hard drive that contains information about the user. The Company does not use cookies to identify individuals. Cookies are session cookies and are not retained once the user closes the browser. Cookies are used for improving customer service, customizing our website, measuring advertising effectiveness, and related purposes.",
        description2:
          'The Company analyzes cookies as statistical data to identify customer interests and concerns and utilizes this information. Cookies are also used to prevent unauthorized access.',
        description3:
          'Cookies can be disabled at customer preference, but doing so will prevent customers from making reservations on LINKTIVITY.'
      },
      logFile: {
        title: 'Log Files',
        description1:
          'The Company automatically collects certain information and saves it to log files. This specific information includes IP (Internet Protocol) addresses, browser types, ISP (Internet Service Provider) names, referring/exit pages, operating systems, and date/time stamps. The Company uses this information for monitoring unauthorized access and customer trend analysis, website management, and tracking customer behavior on our site.',
        description2:
          'However, the Company uses this information in a way that does not identify specific individuals, and does not use the information collected for purposes other than those stated above.'
      },
      webBeacon: {
        title: 'Web Beacons',
        description:
          'The Company uses web beacons for access analysis and affiliate programs. The Company does not use web beacons for purposes other than those stated above or to identify specific individuals.'
      },
      statisticalAnalysis: {
        title: 'Statistical Analysis',
        description1:
          'The Company uses third-party access analysis tools to identify which sites and services are popular, and records pages accessed by customers within LINKTIVITY and page history.',
        description2:
          'The Company uses this data to provide content and advertising tailored to the interests of customers who have shown interest in specific areas within LINKTIVITY.',
        description3:
          'The Company may also collect statistical information that does not identify individuals. Furthermore, cookie information collected by the Company and cookie information collected by other parties may be made viewable to both parties on the third-party access analysis tool platform.'
      }
    },
    policy5: {
      title: 'Handling of Anonymized Information',
      creation: {
        title: 'Creation of Anonymized Information',
        description1:
          'When creating anonymized information, the Company takes the following measures. Anonymized information is information about individuals obtained by processing personal information in a manner that prevents identification of specific individuals, in accordance with legal requirements, such that the original personal information cannot be restored.',
        description2:
          '① Processing in accordance with legally prescribed standards ② Implementing safety management measures to prevent disclosure of deleted information and information about processing methods ③ Publicly disclosing the items of information about individuals contained in the created anonymized information ④ Not engaging in acts to identify the original individual from the personal information used to create the anonymized information'
      },
      provision: {
        title: 'Provision of Anonymized Information',
        description:
          'When providing anonymized information to third parties, the Company publicly discloses the items of information about individuals contained in the anonymized information and the method of provision, and clearly indicates to the recipient that the information being provided is anonymized information.'
      },
      disclosure: {
        title: 'Disclosure Regarding Anonymized Information',
        creationSubtitle: 'Regarding Creation of Anonymized Information',
        creationDescription:
          'Regarding the following customer personal information held by the Company, the Company continuously creates anonymized information while taking appropriate measures to prevent identification of specific individuals and to ensure that the original personal information cannot be restored.',
        itemsTitle:
          'Items of Information About Individuals Contained in Anonymized Information',
        itemsDescription:
          'Information collected regarding platform service provision: purchase date, participation date, voucher language, sales amount range, number of participants, reservation status (confirmed or canceled), supplier location and prefecture information, travel agency location country.',
        thirdPartyTitle: 'Third-Party Provision of Anonymized Information',
        thirdPartyDescription:
          'Regarding anonymized information created or held by the Company, the Company continuously provides this information to third parties while clearly indicating that the information is anonymized information.',
        provisionMethod:
          'Password-protected electronic files sent through electronic communication means (email, server upload, API integration, etc.) or physical media (such as DVD).'
      }
    },
    policy6: {
      title: 'Safety Management Measures for Personal Data',
      description1:
        'The Company implements organizational, technical, and physical safety management measures to prevent leakage, theft, misuse, unauthorized access, alteration, and destruction of personal data. Access to the server where the Company stores personal data is restricted to authorized employees with ID and password access, and access to certain personal data is granted only to the minimum necessary employees for data management.',
      description2:
        'Furthermore, personal data including credit card information is stored in a secure environment distributed across multiple data centers. The Company uses Secure Sockets Layer (SSL) encryption for all pages related to reservation transactions. Using an SSL-compliant browser maintains the confidentiality of personal data and credit card information transmitted over the Internet.',
      description3:
        'Employees of the Company who handle customer personal data use password-protected screen savers when away from their terminals.',
      description4:
        'Furthermore, the Company conducts educational training regarding the importance of personal information once a month for certain departments and at least twice a year company-wide. The Company also maintains records of such training.'
    },
    policy7: {
      title: 'Rights of Customers Regarding Handling of Personal Data',
      description:
        'Based on the EU General Data Protection Regulation (GDPR) 2016/679 dated April 27, 2016, customers have the following rights regarding processing of personal data:',
      right1: 'Right of access',
      right2: 'Right to rectification',
      right3:
        'Right to erasure (right to be forgotten) and right to restrict processing',
      right4: 'Data portability right',
      right5: 'Right to object',
      right6:
        'Right not to be subject to automated decision-making based on profiling, including.'
    },
    policy8: {
      title: 'Requests for Disclosure, Rectification, Suspension of Use, etc.',
      description1:
        'The Company responds to requests from customers for notification of purpose of use of held personal data, requests for disclosure, requests for correction/addition/deletion, requests for suspension/deletion of use, and requests to stop third-party provision (collectively referred to as "requests for disclosure, etc.") through the contact information listed in section 11 below.',
      description2:
        "Additionally, the Company responds to customer wishes to change and confirm member information and suspend distribution of email magazines through the customer's account page."
    },
    policy9: {
      title: 'Regarding External Links',
      description:
        'The LINKTIVITY homepage contains links to other websites. This Privacy Policy applies only to information collected through the LINKTIVITY homepage, and the Company is not responsible for the privacy policies or content of other websites. Customers are requested to read the privacy policies of linked websites and confirm how their personal information is handled.'
    },
    policy10: {
      title: 'Changes to Privacy Policy',
      description:
        'The Company publishes this Privacy Policy on the LINKTIVITY homepage so that customers can always know what personal information the Company collects, for what purposes, and how it is used. Changes to this Privacy Policy are also published on the LINKTIVITY homepage and disclosed to customers.'
    },
    policy11: {
      title: 'Contact Information',
      description1:
        "For questions regarding the Company's Privacy Policy, the Company's personal information protection efforts, the collection and use of customer personal information, or to make a request for disclosure, etc., please use the contact form below. A representative will respond within 5 business days.",
      company: 'Linktivity Inc.',
      address:
        '19F Hibiya Park Front, 2-1-6 Uchisaiwaicho, Chiyoda Ward, Tokyo 100-0011',
      dpoContact: 'Data Protection Officer Contact: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: 'Personal Information Collected',
      specificPurpose: 'Specific Purpose of Use',
      legalBasis: 'Legal Basis:',
      provisionMethod: 'Method of Provision'
    }
  }
};
